
export enum URL {
    BLS_WEBSITE = "https://blsglobal.net",
    FACEBOOK    = "https://www.facebook.com/blacklinesprinting",
    INSTAGRAM   = "https://www.instagram.com/black_line_sprinting",
}